/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditControllerListAuditLogsV1200,
  AuditControllerListAuditLogsV1Params
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAuditControllerListAuditLogsV1Url = (params?: AuditControllerListAuditLogsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/audit-logs?${stringifiedParams}` : `/v1/audit-logs`
}

/**
 * @summary Audit entries for the caller’s agency
 */
export const auditControllerListAuditLogsV1 = async (params?: AuditControllerListAuditLogsV1Params, options?: RequestInit): Promise<AuditControllerListAuditLogsV1200> => {

  return apiRequest<AuditControllerListAuditLogsV1200>(getAuditControllerListAuditLogsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuditControllerListAuditLogsV1QueryKey = (params?: AuditControllerListAuditLogsV1Params,) => {
    return [
    `/v1/audit-logs`, ...(params ? [params] : [])
    ] as const;
    }


export const getAuditControllerListAuditLogsV1QueryOptions = <TData = Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError = unknown>(params?: AuditControllerListAuditLogsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuditControllerListAuditLogsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>> = ({ signal }) => auditControllerListAuditLogsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuditControllerListAuditLogsV1QueryResult = NonNullable<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>>
export type AuditControllerListAuditLogsV1QueryError = unknown


export function useAuditControllerListAuditLogsV1<TData = Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError = unknown>(
 params: undefined |  AuditControllerListAuditLogsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>,
          TError,
          Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerListAuditLogsV1<TData = Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError = unknown>(
 params?: AuditControllerListAuditLogsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>,
          TError,
          Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuditControllerListAuditLogsV1<TData = Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError = unknown>(
 params?: AuditControllerListAuditLogsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Audit entries for the caller’s agency
 */

export function useAuditControllerListAuditLogsV1<TData = Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError = unknown>(
 params?: AuditControllerListAuditLogsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof auditControllerListAuditLogsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuditControllerListAuditLogsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






